import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(periodicTasksRoute);

    /** @ngInject */
    function periodicTasksRoute($stateProvider) {
        $stateProvider
            .state('company_employee.periodic_tasks', {
                url: '/zadania-cykliczne',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/periodic_tasks/periodic_tasks.html'),
            })
            .state('company_employee.periodic_tasks.create_task', {
                url: '/nowe-zadanie',
                template: '<im-task-form></im-task-form>',
            })
            .state('company_employee.periodic_tasks.edit_task', {
                url: '/edytuj-zadanie/:id',
                template: '<im-task-form></im-task-form>',
            })
            .state('company_employee.periodic_tasks.task_list', {
                url: '/lista-zadan',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/periodic_tasks/task_list/task_list.html'),
                controller: 'TaskListController',
                controllerAs: 'TaskListCtrl',
            })
            .state('company_employee.periodic_tasks.task_list.task_details', {
                url: '/zadanie/:id',
                template:
                    require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/periodic_tasks/task_details/task_details.html'),
                controller: 'TaskDetailsController',
                controllerAs: 'TaskDetailsCtrl',
            });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/periodic_tasks.route.ts